export const VENDOR_KEY = 'vendor';
export const SPACE_REGEX = /\s+/g;

export const VENDOR_RESPONSE_ID = 'org-response-paragraph';
export const CREW_RESPONSE_ID = 'crew-response-paragraph';
export const VENDOR_SALUTATION_ID = 'org-salutation-paragraph';
export const CREW_SALUTATION_ID = 'crew-salutation-paragraph';
export const DRAFT_BOOKING_FROM_LEAD = 'draftBookingFromLead';
export const SALUTATION = 'salutation';

export const AUTO_GENERATED_ROW_PREFIX = 'auto-generated-row-';

export const AUTO_GENERATED_GROUP_ROW_FOOTER = 'auto-generated-group-footer-root';

export const OPPORTUNITY_STATES = {
    booking: 'Booking',
    requisition: 'Requisition'
} as const;

export const OPPORTUNITY_STATUS = {
    inquiry: 'Inquiry',
    booked: 'Booked'
} as const;

export const CREATED_FROM_TYPE = {
    opportunity: 'opportunity'
};

export const inquiryResponseStatuses = {
    yes: 'Available',
    no: 'Not Available',
    requestInfo: 'Information Requested',
    requestSent: 'Request Sent'
};

export const lineItemGroupTypes = {
    group: 'Group',
    item: 'Item',
    child: 'Child'
};

export const CONTEXT_TERM = {
    bookingProductionShare: 'bookingProductionShare',
    bookingSupplierShare: 'bookingSupplierShare'
};

export const OPPORTUNITY_TYPE = {
    other: 'other'
};

export const BOOKING_ACCESS_LINK = 'booking-access-link';

export const OPPORTUNITY_FIELDS = {
    lineItem: 'lineItem'
};

export const COLUMN_NAMES = {
    icons: 'icons',
    name: 'name',
    packageType: 'packageType',
    start: 'start',
    end: 'end',
    associatedItems: 'associatedItems',
    rate: 'rate',
    rateType: 'rateType',
    baseTotal: 'baseTotal',
    discountAmount: 'discountAmount',
    itemTotal: 'itemTotal',
    quantity: 'quantity',
    discountedTotal: 'discountedTotal',
    discountRate: 'discountRate',
    duration: 'duration',
    discountedRate: 'discountedRate',
    area: 'area',
    discountPercentage: 'discountPercentage',
    subType: 'productSubType',
    togglePanel: '__detail_panel_toggle__'
};

export const LINE_ITEM_ACTIONS = {
    reservation: 'reservation',
    guests: 'guests'
} as const;

export const KEY_DATES_ACTIVITY_TYPE = {
    mark: 'mark',
    unmark: 'unmark'
};
